import React from "react";

import { connect } from "react-redux";
import { Panel, PanelHeader, Div, Text, Button } from "@vkontakte/vkui";
import Icon24Back from "@vkontakte/icons/dist/24/back";
import styles from "./ErrorPanel.style";
import Header from "../Header";
import UserAvatar from "../UserAvatar";
import {
  setActiveNonErrorPanel,
  setPreviousPanel,
} from "../../redux/actions/panelsActions";

const ErrorPanel = ({ id, userInfo, goBack, repeatRequest }) => {
  const onGoBackClick = () => {
    goBack();
  };

  const onRepeatButtonClick = () => {
    repeatRequest();
  };
  return (
    <Panel id={id}>
      <PanelHeader
        separator={false}
        left={
          <Div
            style={{
              display: "flex",
            }}
          >
            <Header />
            <UserAvatar userInfo={userInfo} />
          </Div>
        }
      />
      <Div style={styles.goBackWrapper} onClick={onGoBackClick}>
        <Icon24Back fill="#06844D" />
        <Text style={styles.goBackText}>Назад</Text>
      </Div>
      <Text style={styles.errorHeader}>Что-то пошло не так</Text>
      <Text style={styles.errorMessage}>
        Сервер временно не доступен. Пожалуйста, повторите попытку позже.
      </Text>
      <Button style={styles.repeatButton} onClick={onRepeatButtonClick}>
        Повторить
      </Button>
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo.userInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => dispatch(setPreviousPanel()),
    repeatRequest: () => dispatch(setActiveNonErrorPanel()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ErrorPanel);
